import axios from "axios"
import config from "../config"

const api_single = "call"

export const bargeIn = livecallid => dispatch => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}${api_single}/${livecallid}/bargein`)
            .then(() => {})
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const listenIn = livecallid => dispatch => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}${api_single}/${livecallid}/listenin`)
            .then(() => {})
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const update = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        axios
            .put(`${config.apiEndpoint}${api_single}/${id}`, data)
            .then(() => resolve())
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const transcriptUpload = (id, data) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${config.apiEndpoint}${api_single}/${id}/transcription`, data)
            .then(response => resolve(response.data))
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const callStarted = data => {
    return {
        type: "CALL_STARTED",
        data: data,
    }
}

export const callFinished = () => {
    return {
        type: "CALL_FINISHED",
    }
}
